import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree} from '@angular/router';
import {LicenseService} from '@q9elements/ui-kit/common';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';

export const changeMonitoringLicenseGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const licenseService = inject(LicenseService);
  const router = inject(Router);
  const refModelId = route.params['refModelId'];

  return authService.fetchUser(refModelId).pipe(
    map(() => {
      if (licenseService.hasChangeMonitoringLicense()) {
        return true;
      }

      return router.createUrlTree(['/refmodel', refModelId], {
        queryParams: {paywallFor: 'changeMonitoring'}
      });
    })
  );
};
